/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'slots-all': {
    width: 16,
    height: 16,
    viewBox: '0 0 271.673 271.673',
    data: '<path pid="0" d="M114.939 0H10.449C4.678 0 0 4.678 0 10.449v104.49c0 5.771 4.678 10.449 10.449 10.449h104.49c5.771 0 10.449-4.678 10.449-10.449V10.449C125.388 4.678 120.71 0 114.939 0zM261.224 0h-104.49c-5.771 0-10.449 4.678-10.449 10.449v104.49c0 5.771 4.678 10.449 10.449 10.449h104.49c5.771 0 10.449-4.678 10.449-10.449V10.449C271.673 4.678 266.995 0 261.224 0zM114.939 146.286H10.449C4.678 146.286 0 150.964 0 156.735v104.49c0 5.771 4.678 10.449 10.449 10.449h104.49c5.771 0 10.449-4.678 10.449-10.449v-104.49c0-5.771-4.678-10.449-10.449-10.449zM261.224 146.286h-104.49c-5.771 0-10.449 4.678-10.449 10.449v104.49c0 5.771 4.678 10.449 10.449 10.449h104.49c5.771 0 10.449-4.678 10.449-10.449v-104.49c0-5.771-4.678-10.449-10.449-10.449z"/>'
  }
})
